import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { MailQuestion, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { identifier: identifier.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-brand rounded-xl p-3 text-white"><MailQuestion className="w-7 h-7" /></div>
          <div>
            <h1 className="font-display text-3xl font-bold">Password dimenticata</h1>
            <p className="text-neutral-600 text-base">Ti invieremo un link per reimpostarla</p>
          </div>
        </div>
        {sent ? (
          <div className="bg-white p-6 rounded-xl border-2 space-y-4">
            <div className="flex items-center gap-2 text-green-700 font-bold text-lg"><CheckCircle2 className="w-6 h-6" /> Richiesta inviata</div>
            <p className="text-base text-neutral-700">Se l'account esiste, riceverai un'email con le istruzioni per scegliere una nuova password. Controlla anche la posta indesiderata.</p>
            <Button data-testid="forgot-back" onClick={() => navigate("/login")} className="w-full h-12 bg-brand hover:bg-brand-dark text-white font-bold">Torna all'accesso</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4 bg-white p-6 rounded-xl border-2">
            <div>
              <Label className="text-base font-semibold">Email o ID di accesso</Label>
              <Input data-testid="forgot-identifier" value={identifier} onChange={(e) => setIdentifier(e.target.value)}
                required className="h-14 text-lg mt-1.5" placeholder="m.rossi oppure nome@email.it" />
            </div>
            {error && <div data-testid="forgot-error" className="p-4 bg-red-50 border-2 border-red-200 text-red-800 rounded-lg text-base font-semibold">{error}</div>}
            <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full h-14 text-lg font-bold bg-brand hover:bg-brand-dark text-white">
              {loading ? <Loader2 className="w-6 h-6 animate-spin" /> : "Invia link di reset"}
            </Button>
            <button type="button" onClick={() => navigate("/login")} className="w-full text-center text-neutral-600 font-semibold hover:underline flex items-center justify-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Torna all'accesso
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
